<template>
  <div class="datepicker-days">
    <table class="table-condensed">
      <thead>
        <tr>
          <th class="prev" @click.prevent="previous">
            <span
              class="glyphicon glyphicon-chevron-left"
              title="Previous Month"
            ></span>
          </th>
          <th
            class="picker-switch"
            colspan="5"
            title="Select Month"
            @click="showMonth"
          >
            {{ month }} {{ year }}
          </th>
          <th class="next" @click.prevent="next">
            <span
              class="glyphicon glyphicon-chevron-right"
              title="Next Month"
            ></span>
          </th>
        </tr>
        <tr>
          <th class="dow">Mo</th>
          <th class="dow">Tu</th>
          <th class="dow">We</th>
          <th class="dow">Th</th>
          <th class="dow">Fr</th>
          <th class="dow">Sa</th>
          <th class="dow">Su</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(dates, index7days) in datesOfMonth"
          :key="index7days"
          class="flex"
          :class="{
            'last-week-of-month': index7days === datesOfMonth.length - 1
          }"
        >
          <td
            v-for="(date, indexDay) in dates"
            :key="indexDay"
            class="day"
            :class="[
              { old: isPreviousMonth(date) },
              { '': inCurrentMonth(date) },
              { new: isNextMonth(date) },
              { 'last-day-of-week': indexDay === dates.length - 1 },
              { active: isToday(date) }
            ]"
            @click="selectDate(date)"
          >
            {{ date.format('D') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import { chunk } from 'lodash'

export default {
  name: 'DayPicker',
  props: {
    currentDate: {
      default: () => moment()
    },
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    }
  },
  computed: {
    datesOfMonth() {
      let date = []

      for (
        let i = moment(this.currentDate)
          .startOf('month')
          .weekday();
        i > 0;
        i--
      ) {
        date.push(
          moment(this.currentDate)
            .startOf('month')
            .add(i * -1, 'days')
        )
      }

      for (
        let j = 0;
        j <
        moment(this.currentDate)
          .endOf('month')
          .format('DD');
        j++
      ) {
        date.push(
          moment(this.currentDate)
            .startOf('month')
            .add(j, 'days')
        )
      }

      for (
        let k = 1;
        k <=
        6 -
          moment(this.currentDate)
            .endOf('month')
            .weekday();
        k++
      ) {
        date.push(
          moment(this.currentDate)
            .endOf('month')
            .add(k, 'days')
        )
      }

      return chunk(date, 7)
    },
    isPreviousMonth: vm => date => {
      return (
        date.format('MM') < moment(vm.currentDate).format('MM') ||
        date.format('YYYY') < moment(vm.currentDate).format('YYYY')
      )
    },
    inCurrentMonth: vm => date => {
      return (
        date.format('MM') === moment(vm.currentDate).format('MM') &&
        date.format('YYYY') === moment(vm.currentDate).format('YYYY')
      )
    },
    isNextMonth: vm => date => {
      return (
        date.format('MM') > moment(vm.currentDate).format('MM') ||
        date.format('YYYY') > moment(vm.currentDate).format('YYYY')
      )
    },
    month() {
      return this.currentDate.format('MMMM')
    },
    year() {
      return this.currentDate.format('YYYY')
    },
    isToday: vm => date => {
      return (
        moment(vm.currentDate).format(vm.format) ===
        moment(date).format(vm.format)
      )
    }
  },
  methods: {
    previous() {
      this.$emit('select-date', moment(this.currentDate).add(-1, 'months'))
    },
    next() {
      this.$emit('select-date', moment(this.currentDate).add(1, 'months'))
    },
    calculateDayInterval(fromDate, toDate) {
      return moment.duration(moment(toDate).diff(moment(fromDate))).as('days')
    },
    showMonth() {
      this.$emit('change-picker', 'month')
    },
    selectDate(selectedDate) {
      this.$emit('select-date', selectedDate)
    },
    selectMonth(selectedMonth) {
      this.$emit('select-month', selectedMonth.toString())
    },
    selectYear(selectedYear) {
      this.$emit('select-year', selectedYear.toString())
    }
  }
}
</script>
